import { render, staticRenderFns } from "./ProductDesignFormFabric2.vue?vue&type=template&id=b65e6156&"
import script from "./ProductDesignFormFabric2.vue?vue&type=script&lang=js&"
export * from "./ProductDesignFormFabric2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports